"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssAnchorName = exports.SSRError = void 0;

var _preact = require("preact");

var cssAnchorName = 'ssr-error-display';
exports.cssAnchorName = cssAnchorName;

/**
 * SSR Error Display Component - Minimal debug information
 *
 * Only rendered in __debugMode - shows essential error info without breaking production
 */
var SSRError = function SSRError(_ref) {
  var errorSource = _ref.errorSource,
      componentPath = _ref.componentPath,
      errorMessage = _ref.errorMessage;
  return (0, _preact.h)("details", {
    open: true,
    style: {
      border: '2px solid #f00',
      padding: '1em',
      margin: '1em 0',
      background: '#fff5f5'
    }
  }, (0, _preact.h)("summary", {
    style: {
      cursor: 'pointer',
      fontWeight: 'bold'
    }
  }, "\u274C SSR Error in ", (0, _preact.h)("b", null, errorSource)), (0, _preact.h)("div", {
    style: {
      marginLeft: '1.5em'
    }
  }, (0, _preact.h)("p", null, (0, _preact.h)("strong", null, "Component:"), " ", (0, _preact.h)("code", null, componentPath)), (0, _preact.h)("p", null, (0, _preact.h)("strong", null, "Error:"), " ", errorMessage)));
};

exports.SSRError = SSRError;